module.exports = __webpack_public_path__ + "static/integration/img/ally-icon-indicator-high-circle.f608a8b5a3987a75cfaf1554d59e0192.svg";